export enum SEU_API_ENDPOINTS {
  setup = '/setup',
  offerDetail = '/offers/:offerId',
  archiveOffer = '/offers/:offerId/archive',
  offers = '/offers',
  interconnection = '/offers/:offerId/interconnections',
  opex = '/offers/:offerId/opex',
  emissionLimits = '/offers/:offerId/emissionLimits',
  interconnectionDetail = '/offers/:offerId/interconnections/:interconnectionId',
  interconnectionDuplicate = '/offers/:offerId/interconnections/:interconnectionId/duplicate',
  calculationCombinations = '/offers/:offerId/calculationCombinations',
  globalParameter = '/offers/:offerId/globalParameterSets',
  globalParameterDetail = '/offers/:offerId/globalParameterSets/:globalParameterId',
  globalParameterDefault = '/offers/:offerId/globalParameterSets/:globalParameterId/default',
  operatingCondition = '/offers/:offerId/interconnections/:interconnectionId/operatingConditions',
  operatingConditionDetail = '/offers/:offerId/interconnections/:interconnectionId/operatingConditions/:operatingConditionId',
  operatingConditionActivate = '/offers/:offerId/interconnections/:interconnectionId/operatingConditions/:operatingConditionId/active',
  operatingConditionDuplicate = '/offers/:offerId/interconnections/:interconnectionId/operatingConditions/:operatingConditionId/duplicate',
  filterComponent = '/offers/:offerId/interconnections/:interconnectionId/components',
  filterComponentDetail = '/offers/:offerId/interconnections/:interconnectionId/components/:componentId',
  canvas = '/offers/:offerId/interconnections/:interconnectionId/canvas',
  calculation = '/offerComputations/offers/:offerId',
  defaultUnits = '/offers/:offerId/defaultUnits',
  userProfile = '/user/profile',
  endEditSession = '/offers/active-editor-session/:editSessionId/end?reson=:reason',
}
